/* unplugin-vue-components disabled */import script from "./XSearchTree.vue?vue&type=script&lang=ts&setup=true"
export * from "./XSearchTree.vue?vue&type=script&lang=ts&setup=true"

import "./XSearchTree.vue?vue&type=style&index=0&id=ec1fe630&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec1fe630"]])

export default __exports__